<template>
  <div class="app-container">
    <el-card class="box-card mt10">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <!-- <el-form-item label="推送类型：">
            <el-select v-model="query.type" placeholder="请选择" filterable clearable size="small">
              <el-option label="订单" :value="1"></el-option>
              <el-option label="充值" :value="2"></el-option>
              <el-option label="会议报名" :value="3"></el-option>
              <el-option label="升级身份" :value="4"></el-option>
              <el-option label="课程订单" :value="5"></el-option>
              <el-option label="售后补差价" :value="7"></el-option>
              <el-option label="现金支付取消订单到余额" :value="201"></el-option>
              <el-option label="退货到余额" value="tuihuosongyue"></el-option>
              <el-option label="退货到零售价" value="tuihuosongxiaodubi"></el-option>
              <el-option label="使用余额支付后取消订单退回余额" value="quxiaodingdantuihuiyue"></el-option>
              <el-option label="使用零售价支付后取消订单退回零售价" value="quxiaodingdantuihuiXDB"></el-option>
              <el-option label="使用赠送账户支付后取消订单退回赠送账户" value="quxiaodingdantuihuiZS"></el-option>
              <el-option label="使用余额支付订单" value="kaidanshiyongyue"></el-option>
              <el-option label="使用零售价支付订单" value="kaidanshiyongxiaodubi"></el-option>
              <el-option label="使用赠送账户支付订单" value="kaidanshiyongZS"></el-option>
              <el-option label="使用凭证升级赠送学费账户" value="shengjisongZS2"></el-option>
              <el-option label="使用凭证充值送零售价" value="chongzhisongxiaodubiXXCZ"></el-option>
              <el-option label="使用凭证充值后入账余额账户" value="xianxiachongzhisongyueXXCZ"></el-option>
              <el-option label="旧系统账户导入余额" value="houtai_daoruyue"></el-option>
              <el-option label="在线充值送零售价" value="chognzhisongxiaodubi"></el-option>
              <el-option label="旧系统账户导入零售价" value="houtai_daoruxiaodubi"></el-option>
              <el-option label="旧系统账户导入学费" value="houtai_daoruxuefei"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="订单号：">
            <el-input v-model="query.no" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="类型名称：">
            <el-input v-model="query.title" placeholder="请输入类型名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="推送摘要：">
            <el-input v-model="query.summary" placeholder="请输入推送摘要" clearable size="small" />
          </el-form-item>
          <!-- <el-form-item label="姓名：">
            <el-input v-model="query.nameorpho" placeholder="请输入客户姓名/手机号" clearable size="small" />
          </el-form-item> -->
          <el-form-item label="推送状态：">
            <el-select v-model="query.isSuccess" placeholder="请选择" clearable size="small">
              <el-option label="待推送" :value="0"></el-option>
              <el-option label="推送成功" :value="1"></el-option>
              <el-option label="推送失败" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账套名称 ：">
            <el-select v-model="query.yongyouConfigId" placeholder="请选择账套名称" clearable size="small">
              <el-option v-for="(item,index) in companyList" :key="index" :label="item.namestr" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="制单时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="primary" @click="handleRefresh" size="mini">刷新用友登录token</el-button>
            <el-button type="success" @click="handleBatchPush" size="mini" :disabled="selectItems.length === 0 || batchPushing">
              {{ batchPushing ? `批量推送中(${batchPushProgress}/${selectItems.length})` : '批量推送' }}
            </el-button>
            <!-- <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-table v-loading="listLoading" :data="list " @selection-change="selectionChange">
        <el-table-column type="selection" width="50" />
        <!-- <el-table-column label="推送类型" prop="deptName" align="center" fixed>
          <template slot-scope="{row}">
            {{orderStatus(row.code)}}
          </template>
        </el-table-column> -->
        <el-table-column label="订单单号" prop="orderNumber" align="center">
        </el-table-column>
        <!-- <el-table-column label="交易单号" prop="payResponse.newbizContent.termrefnum" align="center">
          <template slot-scope="{row}">
            {{(row.payResponse && row.payResponse.newbizContent && row.payResponse.newbizContent.termrefnum) || (row.payResponse && row.payResponse.termrefnum)}}

          </template>
        </el-table-column> -->
        <el-table-column label="推送名称" prop="title" align="center" />
        <el-table-column label="账套名称" prop="cityName" align="center" />
        <el-table-column label="用友凭证编码" prop="id" align="center">
          <template slot-scope="{row}">SC_ {{ row.id }}</template>
        </el-table-column>
        <el-table-column label="制单时间" prop="bizDate" align="center" />
        <el-table-column label="摘要" prop="summary" align="center" />
        <el-table-column label="金额" prop="money" align="center" />
        <!-- <el-table-column label="做账时间" prop="bizDate" align="center" sortable width="200">
        </el-table-column> -->
        <!-- <el-table-column label="推送成功时间" prop="sendLog.createdTime" align="center" sortable width="200">
        </el-table-column> -->
        <el-table-column label="推送状态" prop="deptStatus" align="center" width="150">
          <template slot-scope="{row}">
            <el-tag type="" effect="dark" v-if="row.state === 1" size="mini">推送成功</el-tag>
            <el-tag type="danger" effect="dark" v-else-if="row.state === 2" size="mini">推送失败</el-tag>
            <el-tag type="info" effect="dark" v-else size="mini">待推送</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="商户单号" prop="deptName" align="center">
        </el-table-column> -->
        <!-- <el-table-column label="银行卡号" prop="deptName" align="center">
        </el-table-column> -->

        <!-- <el-table-column label="用友系统功能名称" prop="deptName" align="center" width="150">
        </el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <el-button type="text" @click="handlePush(row)">推送</el-button>
            <!-- <el-button type="text" @click="handleDel(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <order-show ref="orderShow" @created="doQueryList({})" />
  </div>
</template>

<script>
import orderShow from './show'
import sysExternalSendLogApi from '@/api/sys/sysExternalSendLog'
import Pagination from '@/components/Pagination'
import homeStatisticsApi from '@/api/home'
import { Subtr, formatDateStr } from '@/utils/index'
import sysToolsApi from '@/api/sys/tools'
import cityCompanyApi from '@/api/sys/cityCompany'
import yongyouConfigApi from '@/api/config/yongyouConfig'
import { dateTime } from '@/utils/dateTime'
import { filterEmpty } from '@/utils/index'
export default {
  components: {
    Pagination,
    orderShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      exceptionObj: {},
      companyList: [],
      dateTime: [],
      batchPushing: false, // 是否正在批量推送
      batchPushProgress: 0 // 批量推送进度
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getException()
    this.getOptionList()
  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case '1':
            return "订单";
            break;
          case '2':
            return "充值";
            break;
          case '3':
            return "会议";
            break;
          case '4':
            return "升级身份";
            break;
          case '5':
            return "课程订单";
            break;
          case '7':
            return "售后补差价";
            break;
          case '201':
            return "现金支付取消订单到余额";
            break;
          case 'tuihuosongyue':
            return "退货到余额";
            break;
          case 'tuihuosongxiaodubi':
            return "退货到零售价";
            break;
          case 'quxiaodingdantuihuiyue':
            return "使用余额支付后取消订单退回余额";
            break;
          case 'quxiaodingdantuihuiXDB':
            return "使用零售价支付后取消订单退回零售价";
            break;
          case 'quxiaodingdantuihuiZS':
            return "使用赠送账户支付后取消订单退回赠送账户";
            break;
          case 'kaidanshiyongyue':
            return "使用余额支付订单";
            break;
          case 'kaidanshiyongxiaodubi':
            return "使用零售价支付订单";
            break;
          case 'kaidanshiyongZS':
            return "使用赠送账户支付订单";
            break;
          case 'shengjisongZS2':
            return "使用凭证升级赠送学费账户";
            break;
          case 'chongzhisongxiaodubiXXCZ':
            return "使用凭证充值送零售价";
            break;
          case 'xianxiachongzhisongyueXXCZ':
            return "使用凭证充值后入账余额账户";
            break;
          case 'houtai_daoruyue':
            return "旧系统账户导入余额";
            break;
          case 'chognzhisongxiaodubi':
            return "在线充值送零售价";
            break;
          case 'houtai_daoruxiaodubi':
            return "旧系统账户导入零售价";
            break;
          case 'houtai_daoruxuefei':
            return "旧系统账户导入学费";
            break;
          default:
            return "类型错误";
            break;
        }
      }

    }
  },
  methods: {
    // 获取城市公司
    getOptionList() {
      yongyouConfigApi.fetchList({ pageNo: 1, pageSize: 1000 }).then(({ data }) => {
        data.list.forEach(item => {
          item.namestr = item.cityCompanyListVO && item.cityCompanyListVO.length > 0 ? item.cityCompanyListVO[0].name : '四川省杜一生教育管理有限公司'
        })
        this.companyList = data.list
      })
    },
    getException() {
      homeStatisticsApi.getHomeException().then(res => {
        let { dinghuoCount, miaoshaCount, jifenCount } = res.data;
        let count = Subtr(Subtr(dinghuoCount, -miaoshaCount), -jifenCount)
        res.data.allOrderCount = count
        res.data.time = formatDateStr(new Date())
        this.exceptionObj = res.data;
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // canLookGoodsPrice: 1,
        // canStudyCourse: 1
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      query.startBizDate = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      query.endBizDate = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.listLoading = true
      return sysExternalSendLogApi.getYongYouVoucherLog(filterEmpty(query))
        .then(({ data }) => {
          data.list.forEach(item => {
            if (item.payResponse) {
              let obj = this.parsePayRequest(item.payResponse)
              item.payResponse = obj;
              item.payResponse.newbizContent = obj.bizContent ? JSON.parse(obj.bizContent) : null
            }
          })
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    parsePayRequest(str) {
      const pairs = str.split(', ');
      const result = {};
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        // 处理 miniprogramPayInfo_VSP 字段，它是一个 JSON 字符串
        if (key === "miniprogramPayInfo_VSP") {
          try {
            result[key] = JSON.parse(value);
          } catch (error) {
            result[key] = value;
          }
        } else {
          result[key] = value;
        }
      });
      return result;
    },
    handleRefresh() {
      sysToolsApi.refreshYongYouToken().then(res => {
        this.$common.showMsg('success', '操作成功')
        return this.doQueryList({ pageNo: 1 })
      })
    },
    // 推送
    handlePush(row) {
      if (row.state === 1) {
        this.$confirm('是否再次推送?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.getSendTS(row)
        })
      } else {
        this.getSendTS(row)
      }
    },
    getSendTS(row) {
      sysToolsApi.toYongYou({ id: row.id }).then(res => {
        let data = res.data
        if (data.state === 1) {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        } else {
          this.$common.showMsg('error', data.returnParameter)
        }

      })
    },
    // 删除
    handleDel(row) {

    },
    /**
     * 打开详情表单
     */
    handleShow(row) {
      this.$refs.orderShow.handleUpdate(row)
    },
    /**
     * 批量推送
     */
    handleBatchPush() {
      if (this.selectItems.length === 0) {
        this.$common.showMsg('warning', '请至少选择一条数据')
        return
      }
      
      this.$confirm(`确定要批量推送选中的 ${this.selectItems.length} 条数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchPushing = true
        this.batchPushProgress = 0
        this.processBatchPush()
      }).catch(() => {
        // 用户取消操作
      })
    },
    /**
     * 处理批量推送，逐个推送选中的数据，每条间隔1秒
     */
    async processBatchPush() {
      const items = [...this.selectItems] // 复制数组，避免在推送过程中被修改
      let successCount = 0
      let failCount = 0
      
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        this.batchPushProgress = i + 1
        
        try {
          await this.pushSingleItem(item)
          successCount++
        } catch (error) {
          failCount++
          console.error(`推送失败，订单号：${item.orderNumber}`, error)
        }
        
        // 如果不是最后一条，等待1秒
        if (i < items.length - 1) {
          await this.sleep(1000)
        }
      }
      
      // 批量推送完成
      this.batchPushing = false
      this.batchPushProgress = 0
      this.selectItems = [] // 清空选中项
      
      // 刷新列表
      await this.doQueryList({ pageNo: this.query.pageNo })
      
      // 显示推送结果
      if (failCount === 0) {
        this.$common.showMsg('success', `批量推送完成！成功推送 ${successCount} 条`)
      } else {
        this.$common.showMsg('warning', `批量推送完成！成功 ${successCount} 条，失败 ${failCount} 条`)
      }
    },
    /**
     * 推送单条数据
     */
    pushSingleItem(item) {
      return new Promise((resolve, reject) => {
        sysToolsApi.toYongYou({ id: item.id }).then(res => {
          let data = res.data
          if (data.state === 1) {
            resolve(data)
          } else {
            reject(new Error(data.returnParameter || '推送失败'))
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * 延迟函数
     */
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
::v-deep .el-divider--horizontal {
  margin-top: 0;
}
</style>
